import TutorialPlayerDetails from "./TutorialPlayer";

export default TutorialPlayerDetails;
